import { useEffect } from 'react';

const useScript = () => {
  useEffect(() => {
    const lib = '//fast.wistia.com/assets/external/E-v1.js';

    const isLoadedScript = (lib) => document.querySelectorAll('[src="' + lib + '"]').length > 0;

    const loadScript = (lib) => {
      const script = document.createElement('script');
      script.setAttribute('src', lib);
      script.id = 'wistiaScript';
      document.getElementsByTagName('head')[0].appendChild(script);

      return script;
    };

    if (!isLoadedScript(lib)) {
      loadScript(lib);
    }

    return () => {
      const scriptElem = document.getElementById('wistiaScript');
      scriptElem?.remove();
    };
  }, []);
};

export default useScript;
